import { SubCompetencyWithEvaluation } from '../types/GrowthWheel'

export const getSelfCompletedCompetencies = (
  subCompetencies: SubCompetencyWithEvaluation[],
) => {
  return subCompetencies.filter(
    sub => sub.evaluation?.selfLevel != null,
  ).length
}

export const getGuidedCompletedCompetencies = (
  subCompetencies: SubCompetencyWithEvaluation[],
) => {
  return subCompetencies.filter(
    sub => sub.evaluation?.leaderLevel != null,
  ).length
}

export const getTotalCompetencies = (
  subCompetencies: SubCompetencyWithEvaluation[],
) => {
  return subCompetencies.length
}

export const getPageTransitionClass = (
  isTransitioning: boolean,
  transitionDirection: 'left' | 'right' | null,
) => {
  return isTransitioning && transitionDirection
    ? `gw-competency-area-page--enter-${transitionDirection}`
    : ''
}

export const getListTransitionClass = (
  isTransitioning: boolean,
  transitionDirection: 'left' | 'right' | null,
) => {
  return isTransitioning && transitionDirection
    ? `gw-competency-area-competencies-list--enter-${transitionDirection}`
    : ''
}

export enum ConfirmModalType {
  FOCUS = 'focus',
  UNFOCUS = 'unfocus',
  ALERT = 'alert',
}
